export default "__VITE_ASSET__Clf9fEgh__"